module.exports = __webpack_public_path__ + "img/seasonal_works_light.5a0fe45b.svg";